/**
 * Rolotoys — Android browser fixes (Chrome, Samsung Internet, WebView)
 */
(function () {
  var CREAM = '#dfe1bf';
  var INK = '#1d3557';
  var isSamsung = /SamsungBrowser/i.test(navigator.userAgent);

  function setColorScheme(el) {
    if (!el || !el.style) return;
    el.style.colorScheme = 'light';
    try {
      el.style.colorScheme = 'only light';
    } catch (e) {
      /* older WebViews */
    }
  }

  function clearFilters(el) {
    if (!el || !el.style) return;
    el.style.webkitFilter = 'none';
    el.style.filter = 'none';
  }

  function forceLightMode() {
    var root = document.documentElement;
    root.setAttribute('data-rolo-light-forced', '');
    if (isSamsung) {
      root.classList.add('rolo-samsung');
    }

    setColorScheme(root);
    root.style.backgroundColor = CREAM;
    clearFilters(root);

    var body = document.body;
    if (!body) return;

    setColorScheme(body);
    body.style.backgroundColor = CREAM;
    body.style.color = INK;
    clearFilters(body);

    var selectors = [
      '.shopify-section-group-header-group',
      '.header-wrapper',
      '.section-header',
      '.header',
      'section.rolo-trust',
      '.rolo-trust',
      '.rolo-trust__inner',
      '.utility-bar',
      '.announcement-bar-section',
      '.rolo-hero',
      '.content-for-layout',
      'main'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (
          el.classList.contains('rolo-hero') ||
          el.classList.contains('utility-bar') ||
          el.classList.contains('announcement-bar-section')
        ) {
          clearFilters(el);
          return;
        }

        el.style.backgroundColor = CREAM;
        el.style.color = INK;
        clearFilters(el);
      });
    });

    document.querySelectorAll('body.rolotoys-theme img, body.rolotoys-theme svg, body.rolotoys-theme video').forEach(function (el) {
      el.style.opacity = '1';
      clearFilters(el);
    });
  }

  function bindSearch(details) {
    if (!details || details.dataset.roloSearchBound) return;
    details.dataset.roloSearchBound = '1';

    var sync = function () {
      document.body.classList.toggle('rolo-search-open', details.hasAttribute('open'));
    };

    details.addEventListener('toggle', sync);
    sync();
  }

  function init() {
    forceLightMode();
    document.querySelectorAll('.header__search details').forEach(bindSearch);

    window.setTimeout(forceLightMode, 0);
    window.setTimeout(forceLightMode, 500);
    window.setTimeout(forceLightMode, 1500);
  }

  forceLightMode();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', forceLightMode);
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', forceLightMode);
  }

  if (isSamsung) {
    var frames = 0;
    function samsungBurst() {
      forceLightMode();
      if (++frames < 180) {
        window.requestAnimationFrame(samsungBurst);
      }
    }
    samsungBurst();
    window.setInterval(forceLightMode, 2000);
  }
})();
